import { Component, Input, OnInit } from '@angular/core';
import { Package } from '../../../models/package.model';
import { FilterService } from '../../../services/filter.service';

@Component({
  selector: 'app-package-card',
  templateUrl: './package-card.component.html',
  styleUrls: ['./package-card.component.scss']
})
export class PackageCardComponent implements OnInit {

  @Input() package: Package;
  @Input() currency: string;
  @Input() cart: boolean;
  @Input() internalUser: boolean;

  constructor(
    public filterService: FilterService
  ) {
  }

  ngOnInit(): void {
  }

}
